module.exports = __webpack_public_path__ + "static/media/felix.f11e6383.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/sponsors/felix.jpg
// module id = 493
// module chunks = 0